import {Button, Modal, Space, Table, Tag, Tooltip} from "antd";
import {
	CheckCircleOutlined,
	CloseCircleOutlined,
	DeleteOutlined,
	EditOutlined,
	StarFilled,
	StarOutlined
} from "@ant-design/icons";

export default function WebpProfilesTable({profiles, onEdit, onDelete, onToggleDefault})
{
	const handleToggleDefault = (profileId, type) =>
	{
		onToggleDefault(profileId, type);
	};

	const handleDelete = (profile) =>
	{
		if (profile.isDefault)
		{
			Modal.confirm({
				title: "Conferma eliminazione",
				content: "Questa impostazione è quella di default. Sei sicuro di volerla eliminare?",
				okText: "Elimina",
				okType: "danger",
				cancelText: "Annulla",
				onOk: () => onDelete(profile.id)
			});
		}
		else
		{
			onDelete(profile.id);
		}
	};

	const columns = [
		{
			title: "Nome",
			dataIndex: "name",
			key: "name",
			width: 200
		},
		{
			title: "Canvas",
			key: "canvas",
			width: 100,
			align: "center",
			render: (_, record) =>
				record.canvas?.enabled ? (
					<CheckCircleOutlined style={{color: "#52c41a", fontSize: 18}}/>
				) : (
					<CloseCircleOutlined style={{color: "#d9d9d9", fontSize: 18}}/>
				)
		},
		{
			title: "Dimensioni",
			key: "dimensions",
			width: 120,
			render: (_, record) =>
				record.canvas?.enabled
					? `${record.canvas.width}×${record.canvas.height}`
					: "-"
		},
		{
			title: "Riemp.",
			key: "fillPercentage",
			width: 90,
			align: "center",
			render: (_, record) =>
				record.canvas?.enabled
					? `${record.canvas.fillPercentage || 100}%`
					: "-"
		},
		{
			title: "Trasparenza",
			key: "transparency",
			width: 120,
			align: "center",
			render: (_, record) =>
				record.transparency ? (
					<Tag color="blue">Attiva</Tag>
				) : (
					<Tag>Disattiva</Tag>
				)
		},
		{
			title: "Colore",
			key: "color",
			width: 100,
			align: "center",
			render: (_, record) =>
				!record.transparency ? (
					<div
						style={{
							width: 40,
							height: 24,
							backgroundColor: record.backgroundColor,
							border: "1px solid #d9d9d9",
							borderRadius: 4,
							margin: "0 auto"
						}}
					/>
				) : (
					"-"
				)
		},
		{
			title: "Qualità",
			dataIndex: "quality",
			key: "quality",
			width: 80,
			align: "center",
			render: (quality) => `${quality}%`
		},
		{
			title: "Default",
			key: "default",
			width: 100,
			align: "center",
			render: (_, record) => (
				<Tooltip title={record.isDefault ? "Rimuovi default" : "Imposta come default"}>
					<Button
						type={record.isDefault ? "primary" : "text"}
						icon={record.isDefault ? <StarFilled/> : <StarOutlined/>}
						onClick={() => handleToggleDefault(record.id)}
						style={{color: record.isDefault ? "#faad14" : undefined}}
					/>
				</Tooltip>
			)
		},
		{
			title: "Azioni",
			key: "actions",
			width: 100,
			align: "center",
			render: (_, record) => (
				<Space>
					<Tooltip title="Modifica">
						<Button
							type="text"
							icon={<EditOutlined/>}
							onClick={() => onEdit(record)}
						/>
					</Tooltip>
					<Tooltip title="Elimina">
						<Button
							type="text"
							danger
							icon={<DeleteOutlined/>}
							onClick={() => handleDelete(record)}
							disabled={profiles.length === 1}
						/>
					</Tooltip>
				</Space>
			)
		}
	];

	return (
		<Table
			columns={columns}
			dataSource={profiles}
			rowKey="id"
			pagination={false}
			size="small"
		/>
	);
}
